import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import {
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { ResizableModule } from "angular-resizable-element";
import { HighchartsChartModule } from "highcharts-angular";
import { CookieService } from "ngx-cookie-service";
import { CountdownModule } from "ngx-countdown";

import { CarouselModule } from "ngx-owl-carousel-o";
import { NgxPaginationModule } from "ngx-pagination";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoaderInterceptor } from "./interceptors/loader-interceptor.service";
import { NgxColorsModule } from "ngx-colors";
import { MaterialModule } from "./material-module";
import { GridsterModule } from "angular-gridster2";
import { LoginPageComponent } from "./pages/login/login.component";
import { NotfoundComponent } from "./pages/errors/notfound/notfound.component";
import { AccessDeniedComponent } from "./pages/errors/denied/denied.component";
import { ServererrorComponent } from "./pages/errors/servererror/servererror.component";

import { AutoOpenMenuComponent } from "./shared/auto-open-menu";
import { HomePageComponent } from "./pages/home/home.component";
import { SettingsPageComponent } from "./pages/settings/settings.component";
import { PublishPageComponent } from "./pages/publish/publish.component";
import { CMSPageComponent } from "./pages/cms/cms.component";
import { CarouselComponent } from "./pages/home/carousel/carousel.component";
import { CanvasListComponent } from "./pages/home/canvas-list/canvas-list.component";
import { PublishCanvasListComponent } from "./pages/publish/canvas-list/canvas-list.component";
import { CMSListComponent } from "./pages/cms/cms-list/cms-list.component";
import { ScheduleCanvasListComponent } from "./pages/publish/schedule-list/schedule-list.component";
import { ApplicationListComponent } from "./shared/application-list/application-list.component";
import { BuilderPageComponent } from "./pages/builder/builder.component";
import { DataFieldComponent } from "./pages/builder/data-field/data-field.component";
import { VisualizationsComponent } from "./pages/builder/visualizations/visualizations.component";
import { OptionsComponent } from "./pages/builder/options/options.component";
import { FiltersComponent } from "./pages/builder/options/filters/filters.component";
import { GroupingComponent } from "./pages/builder/options/grouping/grouping.component";
import { SortingComponent } from "./pages/builder/options/sorting/sorting.component";
import { FormatingComponent } from "./pages/builder/options/formating/formating.component";
import { LinkingComponent } from "./pages/builder/options/linking/linking.component";
import { ColoringComponent } from "./pages/builder/options/coloring/coloring.component";
import { SeriesComponent } from "./pages/builder/options/series/series.component";
import { DataVisibilityComponent } from "./pages/builder/options/data-visibility/data-visibility.component";
import { QuantifiersComponent } from "./pages/builder/options/quantifiers/quantifiers.component";
import { DataLimitComponent } from "./pages/builder/options/limit/limit.component";

import { CanvasItemsComponent } from "./pages/builder/canvas-items/canvas-items.component";
import { BlankChartComponent } from "./pages/builder/canvas-items/chartType/blank-chart/blank-chart.component";
import { HighChartComponent } from "./pages/builder/canvas-items/chartType/high-chart/high-chart.component";
import { TableChartComponent } from "./pages/builder/canvas-items/chartType/table-chart/table-chart.component";
import { ListChartComponent } from "./pages/builder/canvas-items/chartType/list-chart/list-chart.component";
import { DrilldownTableChartComponent } from "./pages/builder/canvas-items/chartType/drilldown-table-chart/drilldown-table-chart.component";
import { textBoxComponent } from "./pages/builder/canvas-items/objectType/text-box/text-box.component";

import { HeaderComponent } from "./shared/header/header.component";
import { CanvasTileComponent } from "./shared/canvas-tile/canvas-tile.component";
import { SpinnerComponent } from "./shared/spinner/spinner.component";

import { DatapointIconsComponent } from "./shared/datapoint-icons/datapoint-icons.component";
import { ChartIconsComponent } from "./shared/chart-icons/chart-icons.component";
import { NavigationComponent } from "./shared/navigation/navigation.component";
import { WidgetBarComponent } from "./shared/widget-bar/widget-bar.component";
import { RelatedBarComponent } from "./shared/related-bar/related-bar.component";

import { ConfigureFilterComponent } from "@dialogs/configure-filter/configure-filter.component";
import { ConfigureSeriesComponent } from "@dialogs/configure-series/configure-series.component";
import { DateGroupOptionsComponent } from "@dialogs/date-group-options/date-group-options.component";
import { ConfigureThresholdsComponent } from "@dialogs/configure-thresholds/configure-thresholds.component";
import { ConfigureThresholdsTableComponent } from "@dialogs/configure-thresholds-table/configure-thresholds-table.component";
import { ConfigureThresholdItemsComponent } from "@dialogs/configure-threshold-items/configure-threshold-items.component";
import { ConfirmLeaveComponent } from "@dialogs/confirm-leave/confirm-leave.component";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { ImportDialogComponent } from "@dialogs/import/import.component";
import { AlertDialogComponent } from "@dialogs/alert/alert.component";
import { PublishingDialogComponent } from "@dialogs/publishing/publishing.component";
import { CreateDialogComponent } from "@dialogs/create/create.component";
import { WidgetDialogComponent } from "@dialogs/widget/widget.component";
import { RenameDialogComponent } from "@dialogs/rename/rename.component";
import { DownloadDialogComponent } from "@dialogs/download/download.component";
import { ErrorDialogComponent } from "@dialogs/error/error.component";
import { AccessDialogComponent } from "@dialogs/access/access.component";
import { InfoDialogComponent } from "@dialogs/info/info.component";
import { FilterLogicComponent } from "@dialogs/filter-logic/filter-logic.component";
import { LinkDialogComponent } from "@dialogs/link/link.component";
import { LogoutComponent } from "@dialogs/logout/logout.component";
import { PreviewDialogComponent } from "@dialogs/preview/preview.component";
import { ExoandDialogComponent } from "@dialogs/expand/expand.component";
import { SearchDialogComponent } from "@dialogs/advanced-search/search.component";
import { CanvasSearchDialogComponent } from "@dialogs/canvas-search/canvas-search.component";
import { DrilldownDialogComponent } from "@dialogs/drilldown/drilldown.component";
import { ViewDialogComponent } from "@dialogs/view/view.component";
import { DetailDialogComponent } from "@dialogs/detail/detail.component";
import { SecurityAccessDialogComponent } from "@dialogs/security-access/security.component";

import { AuthService } from "@services/auth.service";
import { AuthGuardService } from "@services/auth-guard.service";
import { CommonService } from "@services/common.service";
import { DatapointService } from "@services/datapoint.service";
import { DownloadService } from "@services/download.service";
import { LoaderService } from "@services/loader.service";
import { CanvasService } from "@services/canvas.service";
import { FileUploadService } from "@services/file-upload.service";
import { EditorModule } from "@tinymce/tinymce-angular";

import { ReplaceSpacesPipe } from "./pipes/replace-spaces.pipe";
import { CategoryNamePipe } from "./pipes/category-name.pipe";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";

import {
  MatTooltipDefaultOptions,
  MAT_TOOLTIP_DEFAULT_OPTIONS,
} from "@angular/material/tooltip";

// common components
// landing page components
// canvas page components
// report chart type components
// canvas
// services
// created pipes

export const OtherOptions: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchGestures: "auto",
  position: "before",
  touchendHideDelay: 0,
  disableTooltipInteractivity: true,
};

@NgModule({ declarations: [
        AppComponent,
        SpinnerComponent,
        ReplaceSpacesPipe,
        CategoryNamePipe,
        LogoutComponent,
        HomePageComponent,
        PublishPageComponent,
        CMSPageComponent,
        BuilderPageComponent,
        SettingsPageComponent,
        LoginPageComponent,
        HeaderComponent,
        CarouselComponent,
        AutoOpenMenuComponent,
        CanvasListComponent,
        PublishCanvasListComponent,
        CMSListComponent,
        ScheduleCanvasListComponent,
        CanvasTileComponent,
        DataFieldComponent,
        VisualizationsComponent,
        BlankChartComponent,
        TableChartComponent,
        ListChartComponent,
        DrilldownTableChartComponent,
        HighChartComponent,
        DownloadDialogComponent,
        PreviewDialogComponent,
        ExoandDialogComponent,
        DetailDialogComponent,
        SearchDialogComponent,
        SecurityAccessDialogComponent,
        CanvasSearchDialogComponent,
        DrilldownDialogComponent,
        ViewDialogComponent,
        CreateDialogComponent,
        WidgetDialogComponent,
        RenameDialogComponent,
        ConfirmationDialogComponent,
        ImportDialogComponent,
        AlertDialogComponent,
        PublishingDialogComponent,
        ConfirmLeaveComponent,
        ErrorDialogComponent,
        AccessDialogComponent,
        InfoDialogComponent,
        LinkDialogComponent,
        OptionsComponent,
        FiltersComponent,
        NotfoundComponent,
        AccessDeniedComponent,
        ServererrorComponent,
        FilterLogicComponent,
        SortingComponent,
        GroupingComponent,
        DataLimitComponent,
        ConfigureFilterComponent,
        ConfigureSeriesComponent,
        DateGroupOptionsComponent,
        ConfigureThresholdsComponent,
        ConfigureThresholdsTableComponent,
        ConfigureThresholdItemsComponent,
        FormatingComponent,
        ColoringComponent,
        SeriesComponent,
        LinkingComponent,
        CanvasItemsComponent,
        textBoxComponent,
        DataVisibilityComponent,
        QuantifiersComponent,
        DatapointIconsComponent,
        ChartIconsComponent,
        NavigationComponent,
        ApplicationListComponent,
        WidgetBarComponent,
        RelatedBarComponent,
        SafeHtmlPipe,
    ],
    exports: [SafeHtmlPipe],
    bootstrap: [AppComponent], imports: [GridsterModule,
        NgxColorsModule,
        BrowserModule,
        BrowserAnimationsModule,
        EditorModule,
        CarouselModule,
        NgxPaginationModule,
        AppRoutingModule,
        MaterialModule,
        NgSelectModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        CountdownModule,
        HighchartsChartModule,
        ResizableModule], providers: [
        Title,
        HttpClientModule,
        CommonService,
        LoaderService,
        AuthService,
        AuthGuardService,
        CookieService,
        CanvasService,
        DownloadService,
        DatapointService,
        FormGroupDirective,
        FileUploadService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: OtherOptions },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
